module.exports = __webpack_public_path__ + "img/chest-endo-mesomorph-female.95508628.svg";